import { createAsyncThunk } from "@reduxjs/toolkit";
import services from "services";
import _ from "lodash";
import {
  dvrBread,
  scenarioBread,
  channelBread,
  setupBread,
  moduleBread,
  cartBread,
  videoBread,
  logBread,
  BROWSE_MANAGE_STATION,
  BROWSE_DVR_BY_STATION,
  BROWSE_NETWORK,
  CAMERA_SETTING
} from "app/modules/camera/_redux/constants";
import { MODULE_NAME } from "app/modules/camera/_redux/constants";

// Video
const browseVideoRequest = createAsyncThunk(
  videoBread.browse,
  async ({ user, isAdmin }, { getState, rejectWithValue }) => {
    try {
      let param = { ..._.get(getState(), "cameraConfig.video.param") };
      const response = await services.IOT.getListVideo(param);
      if (response && response.data) {
        return _.map(_.get(response, "data.videos"), data => ({
          ...data,
          _id: `${data.pkg_log_id}-${data.channel_no}-${data.dvr_no}`
        }));
      }
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

// Video
const browseLogRequest = createAsyncThunk(
  logBread.browse,
  async (param, { rejectWithValue }) => {
    try {
      const response = await services.IOT.getListLog(param);
      if (response && response.success) {
        return response;
      }
      return response;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
const browseStatisticRequest = createAsyncThunk(
  logBread.browse,
  async (param, { rejectWithValue }) => {
    try {
      const response = await services.IOT.getListStationStatistic(param);
      if (response && response.success) {
        return response;
      }
      return response;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
// Dvr
const browseDvrRequest = createAsyncThunk(
  dvrBread.browse,
  async (param, { rejectWithValue }) => {
    try {
      if (param.station_search_object) {
        let jsonStation = JSON.stringify(param.station_search_object);
        param.station_search = jsonStation;
      }
      const response = await services.IOT.getListDvrInfo(param);
      return { ...response, data: response.data };
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
const browseCrossScenarioByStationIdRequest = createAsyncThunk(
  scenarioBread.browse,
  async (station_id, { rejectWithValue }) => {
    try {
      const response = await services.IOT.getCrossScenarioByStation(station_id);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
const browseChannelsByDvrsRequest = createAsyncThunk(
  channelBread.browse,
  async ({ listDvr }, { rejectWithValue }) => {
    try {
      const response = await services.IOT.getChannelInfoByDvr(listDvr);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
const browseDvrByStationRequest = createAsyncThunk(
  BROWSE_DVR_BY_STATION,
  async ({ station_id }, { rejectWithValue }) => {
    try {
      const response = await services.IOT.getListDvrByStation(station_id);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
const addDvrRequest = createAsyncThunk(
  dvrBread.add,
  async (param, { rejectWithValue }) => {
    try {
      const response = await services.IOT.createDvr(param);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const addDvrRequestMod = createAsyncThunk(
  dvrBread.add,
  async (param, { rejectWithValue }) => {
    try {
      const response = await services.IOT.createDvrMod(param);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const editDvrRequest = createAsyncThunk(
  dvrBread.edit,
  async (param, { rejectWithValue }) => {
    try {
      const response = await services.IOT.updateDvr(param);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const editDvrModRequest = createAsyncThunk(
  dvrBread.edit,
  async (param, { rejectWithValue }) => {
    try {
      const response = await services.IOT.updateDvrMod(param);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const exportDvrInfoByStationRequest = createAsyncThunk(
  `${MODULE_NAME}/EXPORT_DVR_INFO_BY_STATION`,
  async (param, { rejectWithValue }) => {
    try {
      const response = await services.IOT.exportDvrInfosByStation(param);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
const browseDvrChannelRequest = createAsyncThunk(
  `${MODULE_NAME}/BROWSE_DVR_CHANNEL`,
  async (param, { rejectWithValue }) => {
    return [];
  }
);

// Channel
const browseChannelsByStationRequest = createAsyncThunk(
  channelBread.browse,
  async (station_id, { rejectWithValue }) => {
    try {
      const response = await services.IOT.getChannelInfoByStation(station_id);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
// Scenario
const browseScenarioByStationIdRequest = createAsyncThunk(
  scenarioBread.browse,
  async (station_id, { rejectWithValue }) => {
    try {
      const response = await services.IOT.getScenarioInfoByStation(station_id);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
const createScenarioRequest = createAsyncThunk(
  scenarioBread.add,
  async (scenario, { rejectWithValue }) => {
    try {
      const response = await services.IOT.createScenario(scenario);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const browseCrossScenarioByStationRequest = createAsyncThunk(
  scenarioBread.browse,
  async (station_id, { rejectWithValue }) => {
    try {
      const response = await services.IOT.getCrossScenarioByStation(station_id);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const createCrossScenarioRequest = createAsyncThunk(
  scenarioBread.add,
  async (scenario, { rejectWithValue }) => {
    try {
      const response = await services.IOT.createCrossScenario(scenario);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const updateCrossScenarioRequest = createAsyncThunk(
  scenarioBread.edit,
  async (scenario, scenario_id, { rejectWithValue }) => {
    try {
      const response = await services.IOT.updateCrossScenario(
        scenario,
        scenario_id
      );
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

// Setup
const browseSetupByStationIdRequest = createAsyncThunk(
  setupBread.browse,
  async (station_id, { rejectWithValue }) => {
    try {
      const response = await services.IOT.getSetupByStation(station_id);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
const browseModuleByStationIdRequest = createAsyncThunk(
  moduleBread.browse,
  async (station_id, { rejectWithValue }) => {
    try {
      const response = await services.IOT.getModuleByStation(station_id);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
const browseCartByStationIdRequest = createAsyncThunk(
  cartBread.browse,
  async (station_id, { rejectWithValue }) => {
    try {
      const response = await services.IOT.getCartByStation(station_id);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
const createSetupRequest = createAsyncThunk(
  setupBread.add,
  async (setup, { rejectWithValue }) => {
    try {
      const response = await services.IOT.createSetup(setup);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
const browseManageStationRequest = createAsyncThunk(
  BROWSE_MANAGE_STATION,
  async (param, { rejectWithValue }) => {
    try {
      if (param.status === "0") delete param.status;
      const response = await services.IOT.getStationInfos(param);
      return response;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const browseNetwork = createAsyncThunk(
  BROWSE_NETWORK.browse,
  async (param, { rejectWithValue }) => {
    try {
      const response = await services.IOT.searchNetworkInfo(param);
      return response;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const browseCamSetting = createAsyncThunk(
  CAMERA_SETTING.browse,
  async (key, { rejectWithValue }) => {
    try {
      const response = await services.IOT.getCameraSettingByKey(key);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const manageStationThunks = {
  browseManageStationRequest
};
const videoThunks = {
  browseVideoRequest,
  browseLogRequest,
  browseStatisticRequest
};
const dvrThunks = {
  browseDvrRequest,
  browseCrossScenarioByStationIdRequest,
  browseChannelsByDvrsRequest,
  browseDvrByStationRequest,
  browseDvrChannelRequest,
  addDvrRequest,
  editDvrRequest,
  exportDvrInfoByStationRequest,
  browseChannelsByStationRequest,
  addDvrRequestMod,
  editDvrModRequest
};
const scenarioThunks = {
  browseScenarioByStationIdRequest,
  createScenarioRequest,
  browseCrossScenarioByStationRequest,
  createCrossScenarioRequest,
  updateCrossScenarioRequest
};
const setupThunks = {
  browseSetupByStationIdRequest,
  browseModuleByStationIdRequest,
  browseCartByStationIdRequest,
  createSetupRequest
};

const networkThunks = {
  browseNetwork,
  browseCamSetting
};
export {
  manageStationThunks,
  videoThunks,
  dvrThunks,
  scenarioThunks,
  setupThunks,
  networkThunks
};
